import { MathJax } from 'better-react-mathjax';
import React from 'react';

import { contentHasMath, MacroBootstrap } from './mathJaxConfig';

type QuizMathContentProps = {
    children: React.ReactNode;
    /** Combined stem + options text for math detection and remount key hashing. */
    mathText: string;
    /** Stable remount key when content changes (e.g. question id + hash). */
    mathKey: string;
};

/**
 * Per-question typeset unit. Must render under QuizMathJaxProvider (shared context).
 * Skips MathJax wrapper when content has no math delimiters.
 */
export function QuizMathContent({ children, mathText, mathKey }: QuizMathContentProps) {
    if (!contentHasMath(mathText)) {
        return <>{children}</>;
    }

    return (
        <MathJax key={mathKey} style={{ fontFamily: 'LMSans10, serif' }} dynamic={false}>
            <MacroBootstrap />
            {children}
        </MathJax>
    );
}

export default QuizMathContent;
